import "./gradientMesh.css";

export const GradientMesh = () => (
  <div className="gradient-mesh" aria-hidden="true">
    <div className="gradient-mesh__blob gradient-mesh__blob--1" />
    <div className="gradient-mesh__blob gradient-mesh__blob--2" />
    <div className="gradient-mesh__blob gradient-mesh__blob--3" />
  </div>
);
